import { render } from "./SidebarMenu.vue?vue&type=template&id=c478414a&scoped=true"
import script from "./SidebarMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&setup=true&lang=js"

import "./SidebarMenu.vue?vue&type=style&index=0&id=c478414a&lang=scss&scoped=true"
import "./SidebarMenu.vue?vue&type=style&index=1&id=c478414a&lang=scss"
import "./SidebarMenu.vue?vue&type=style&index=2&id=c478414a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c478414a"],['__file',"src/components/SidebarMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c478414a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c478414a', __exports__)) {
    api.reload('c478414a', __exports__)
  }
  
  module.hot.accept("./SidebarMenu.vue?vue&type=template&id=c478414a&scoped=true", () => {
    api.rerender('c478414a', render)
  })

}


export default __exports__